module.exports = __webpack_public_path__ + "img/pakete-header@2x.c8be4125.jpg";